import React, { useEffect, useState, useRef } from 'react';
import List from '@mui/material/List';
import { generateId } from '../../services/random';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ListItemButton from '@mui/material/ListItemButton';
import PerformanceSongPosition from '../items/PerformanceSongPosition';
import PerformanceListItem from '../items/PerformanceListItem';
import IntervalService from './../../services/intervals';
import EditPerformance from '../dialogs/EditPerformance';
import singersStore from './../../stores/singers';
import sessionStore from './../../stores/session';
import performanceStore from '../../stores/performance';
import favoritesStore from './../../stores/favorites';
import settingsStore from '../../stores/settings';
import playerStore from './../../stores/player';

function SongPositionPerformanceList(props) {

  const [olderPosition, setOlderPosition] = useState(null);
  const [currentPosition, setCurrentPosition] = useState(null);

  useEffect(() => {
    if (props.performance) {
      setOlderPosition(props.performance.position);
      if(props.listRef){
        if(props.listRef.current){
          let posDom = document.getElementById("perf-song-pos-"+props.performance.position)
          if(posDom){
            console.log(posDom.offsetTop)
            props.listRef.current.scrollTop=posDom.offsetTop;
          }       
        }
      }
    }
  }, [props.performance]);

  const handleChoosePosition = (pos) => {
    if ((!currentPosition && currentPosition != 0) && (!olderPosition && olderPosition != 0)) {
      setCurrentPosition(pos);
    } else {
      setOlderPosition(currentPosition);
      setCurrentPosition(pos);
    }
    props.onChoosePosition(pos);
  };

  const performanceList = () => {
    if (props.performances) {
      let augPerformances = structuredClone(props.performances);
      console.log(augPerformances);
      let initialPerformance = null;
      let selectedPerformance = currentPosition;
      if (props.performance) {
        if (currentPosition || currentPosition == 0) {
          let performanceIndex = augPerformances.findIndex(x => x.unique_id === props.performance.unique_id);
          if (performanceIndex != -1) {
            augPerformances.splice(performanceIndex, 1);
            if(currentPosition < props.performances.length){
              augPerformances.splice(currentPosition, 0, { ...props.performance });
            }else{
              augPerformances.splice(props.performances.length, 0, { ...props.performance });
            }
          }
        } else {
          initialPerformance = props.performance.position;
        }
        if(currentPosition >= props.performances.length){
          selectedPerformance = props.performances.length-1;
        }
      } else {
        if (currentPosition || currentPosition == 0) {
          if(currentPosition < props.performances.length){
            augPerformances.splice(currentPosition, 0, {
              unique_id: generateId(8),
              track: props.track,
              position: currentPosition,
              profile: props.currentSingerName ? {name: props.currentSingerName } : null
            });
          }else{
            augPerformances.splice(props.performances.length, 0, {
              unique_id: generateId(8),
              track: props.track,
              position: props.performances.length,
              profile: props.currentSingerName ? {name: props.currentSingerName } : null
            });
          }   
        }
        if(currentPosition >= props.performances.length){
          selectedPerformance = props.performances.length;
        }
      }
      for (let i = 0; i < augPerformances.length; i++) {
        augPerformances[i].position = i;
      }
      return augPerformances.map((performance, index) =>
        <PerformanceSongPosition
          key={index}
          index={index}
          id={"perf-song-pos-"+performance.position}
          performance={performance}
          length={augPerformances.length}
          performanceInitial={initialPerformance}
          performanceSelected={selectedPerformance}
          onChoosePosition={() => {
            if (performance.position == 0) {
              handleChoosePosition(0);
            } else {
              if (props.performance) {
                if (currentPosition || currentPosition == 0) {
                  if (currentPosition < performance.position) {
                    handleChoosePosition(performance.position - 1);
                  } else {
                    handleChoosePosition(performance.position);
                  }
                } else {
                  let performanceIndex = augPerformances.findIndex(x => x.unique_id === props.performance.unique_id);
                  if (performanceIndex < performance.position) {
                    handleChoosePosition(performance.position - 1);
                  } else {
                    handleChoosePosition(performance.position);
                  }
                }
              } else {
                if (currentPosition || currentPosition == 0) {
                  if (currentPosition < performance.position) {
                    handleChoosePosition(performance.position - 1);
                  } else {
                    handleChoosePosition(performance.position);
                  }
                } else {
                  handleChoosePosition(performance.position);
                }
              }
            }
          }}
        />
      );
    }
  };

  return (
    <div ref={props.listRef} style={{ padding: 0 }}>
      <List className="muvika-song-position-list muvika-performance-list">
        {performanceList()}
        <ListItemButton className="muvika-song-position-hovering" onClick={() => {
          if (props.performance) {
            handleChoosePosition(props.performances.length);
          } else {
            handleChoosePosition(props.performances.length);
          }
        }}>
        </ListItemButton>
      </List>
    </div>
  );
}

export default SongPositionPerformanceList;